import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { KEYS } from 'src/app/shared/constants/keys';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
    selector: 'app-container-margin-window',
    templateUrl: './container-margin-window.component.html',
    styleUrls: ['./container-margin-window.component.less'],
    standalone: false
})
export class ContainerMarginWindowComponent implements OnInit, AfterViewInit, OnDestroy {

  displayedColumns: string[] = ['refNo', 'wefDate', 'businessSegment', 'action'];
  dataSource: any[] = [];
  totalRecords = 0;
  pageSizeOptions = this.utilityService.getPageSizeOptions();
  segments: any[] = [];

  refNoFilter = new FormControl('');
  wefDateFilter = new FormControl(null);
  businessSegmentFilter = new FormControl(null);

  addPermission: boolean = false;
  editPermission: boolean = false;
  viewPermission: boolean = false;
  deletePermission: boolean = false;

  private subscription = new Subscription();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private router: Router, private service: DataService, private logger: NGXLogger,
    private permissionService: PermissionService, private utilityService: UtilityService) { }

  ngOnInit(): void {
    this.getAllPermission()
    this.getSegments();
    this.subscription.add(
      this.refNoFilter.valueChanges
        .pipe(debounceTime(300))
        .subscribe(() => this.getContainerMarginList(true))
    );
    this.subscription.add(
      this.wefDateFilter.valueChanges
        .pipe(debounceTime(300))
        .subscribe(() => this.getContainerMarginList(true))
    );
    this.subscription.add(
      this.businessSegmentFilter.valueChanges
        .subscribe(() => this.getContainerMarginList(true))
    );
  }

  ngAfterViewInit(): void {
    this.subscription.add(
      this.paginator.page
        .pipe(tap(() => this.getContainerMarginList()))
        .subscribe()
    );
    this.getContainerMarginList();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getContainerMarginList(resetPageIndex: boolean = false): void {
    if (resetPageIndex) { this.paginator.pageIndex = 0; }
    const criteria: any = {
      page: this.paginator.pageIndex,
      size: this.paginator.pageSize,
      sort: ['createdDate', 'desc']
    };
    if (this.refNoFilter.value) { criteria.refNo = this.refNoFilter.value; }
    if (this.wefDateFilter.value) { criteria.wefDate = this.formatToISODate(this.wefDateFilter.value); }
    if (this.businessSegmentFilter.value) { criteria.businessSegmentId = this.businessSegmentFilter.value; }

    this.service.get(Api.CONTAINER_MARGIN, criteria).subscribe((res: any) => {
      if (res) {
        this.logger.info('Container Margin List', res);
        this.dataSource = res.contents ?? [];
        this.totalRecords = res.totalRecords ?? 0;
        if (!this.dataSource.length) { this.utilityService.notifier('No records found', 'info'); }
      }
    });
  }

  getSegments(): void {
    const companyId = +localStorage.getItem(KEYS.COMPANY_ID);
    if (companyId) {
      this.service.get(Api.COMPANY_BUSINESS_SEGMENT_DD + '/' + companyId).forEach(res => {
        if (res) { this.segments = res; }
      });
    }
  }

  private formatToISODate(date: any): string | null {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  onAdd(): void {
    this.router.navigate([APP_ROUTES.CONTAINER_MARGIN + '/add']);
  }

  onEdit(row: any): void {
    this.router.navigate([APP_ROUTES.CONTAINER_MARGIN + '/edit', row.id]);
  }

   getAllPermission(): void {
    const permissionCodes = [PermissionKey.CONTAINER_MARGIN_ADD, PermissionKey.CONTAINER_MARGIN_EDIT, PermissionKey.CONTAINER_MARGIN_VIEW, PermissionKey.CONTAINER_MARGIN_DELETE];
    const permissions = this.permissionService.checkPermissions(permissionCodes, PermissionKey.CONTAINER_MARGIN);
    this.addPermission = permissions.find(p => p.permissionCode === PermissionKey.CONTAINER_MARGIN_ADD)?.show ?? false;
    this.editPermission = permissions.find(p => p.permissionCode === PermissionKey.CONTAINER_MARGIN_EDIT)?.show ?? false;
    this.viewPermission = permissions.find(p => p.permissionCode === PermissionKey.CONTAINER_MARGIN_VIEW)?.show ?? false;
    this.deletePermission = permissions.find(p => p.permissionCode === PermissionKey.CONTAINER_MARGIN_DELETE)?.show ?? false;
  }
}
